<template>
  <section class="root">
    <div :class="rootClassMap">
      <cms-headline :blok="titleBlok"></cms-headline>
      <dl>
        <div v-for="(e, i) in replacedContend" :class=classMap :key=i>
          <dt @click="toggle" :class="{ 'open': i == 0 && blok.first_open }" data-inspect="dt">
            <h3>{{ e.question }}</h3>
            <cms-material-icon class="icon" icon="chevron_right"></cms-material-icon>
          </dt>
          <dd><cms-rich-content :blok="answerBlok(e)"></cms-rich-content></dd>
        </div>
      </dl>
    </div>
  </section>
</template>

<script>
import cms from "@/mixins/cms.js";
export default {
  mixins: [cms],
  name: "cms-custom-faq",
  computed: {
    titleBlok() {
      return { text: this.blok.title, tag: this.blok.title_tag, color: "primary", size: "sm" }
    },
    replacedContend() {
      if (!this.blok.pattern || !this.blok.replacement) {
        return this.blok.entries
      }
      return this.blok.entries.map(e => {
        return {
          question: e.question.replace(new RegExp(this.blok.pattern, 'g'), this.blok.replacement),
          answer: e.answer
        }
      })
    },
    rootClassMap() {
      return {
        "faq": true,
        "split": this.blok.split,
      }
    },
    classMap() {
      return {
        "collapsable": this.blok.collapsable
      }
    },
  },
  methods: {
    answerBlok(e) {
      return { content: e.answer, pattern: this.blok.pattern, replacement: this.blok.replacement }
    },
    toggle(e) {
      e.currentTarget.classList.toggle("open");
    }
  }
}
</script>


<style scoped>
div.faq {
  display: grid;
  gap: 1rem;
}

dl {
  margin: 0;
}

dt .icon {
  cursor: pointer;
  opacity: 0;
  transition: rotate 200ms linear;
  transform-origin: center;
}

dt.open .icon {
  rotate: 90deg;
  color: var(--crf-accent);
}

dt {
  user-select: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--crf-flip);
  margin: 0;
  padding: 0;
}

dt h3 {
  font-weight: 600;
  font-family: var(--crf-ff-head);
  font-size: clamp(0.8rem, calc(0.92rem + 0.08vw), 0.9rem);
}

dd {
  padding: 0;
  margin: 0.5rem 0 0.75rem 0;
  font-family: var(--crf-ff);
  font-weight: 300;
  color: var(--crf-mute);
}

.collapsable .icon {
  opacity: 1;
}

.collapsable dt {
  cursor: pointer;
}

.collapsable dd {
  opacity: 0;
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 250ms ease-in-out, opacity 10ms linear 125ms;
}

.collapsable dd>* {
  overflow: hidden;
}

.collapsable dt.open+dd {
  opacity: 1;
  grid-template-rows: 1fr;
}

@media only screen and (min-width: 999px) {
  div.faq.split {
    grid-template-columns: 6fr 8fr;
  }
}
</style>
